import React, { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
  BrowserRouter,
} from "react-router-dom";
import { HomePage } from "./content/react-components/pages/HomePage";
import { TestPage } from "./content/react-components/pages/TestPage";
import { LoginPage } from "./content/react-components/pages/LoginPage";
import { AdminPage } from "./content/react-components/pages/AdminPage";

import "./App.css";
import { UserPage } from "./content/react-components/pages/UserPage";
import { CatalogPage } from "./content/react-components/pages/CatalogPage";
import { useAuth } from "./content/react-components/AuthContext";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { user } = useAuth();
  
  useEffect(() => {
    if (!user && isLoggedIn) {
      setIsLoggedIn(false);
    }
  }, [user, isLoggedIn]);

  return (
    <>
    <BrowserRouter basename="/">
      {/* <Router> */}
      <Routes>
        <Route
          path="/"
          element={isLoggedIn ? <HomePage /> : <Navigate to="/login" state={{ from: "/" }} />}
        />
        <Route path="/test" element={<TestPage />} />
        <Route path="/admin" element={isLoggedIn ? <AdminPage /> : <Navigate to="/login" state={{ from: "/admin" }}/>} />
        <Route path="/users" element={isLoggedIn ? <UserPage /> : <Navigate to="/login" state={{ from: "/users" }}/>} />
        <Route path="/catalog" element={isLoggedIn ? <CatalogPage /> : <Navigate to="/login" state={{ from: "/catalog" }} />}/>
        <Route
          path="/login"
          element={<LoginPage setIsLoggedIn={setIsLoggedIn} />}
        />
      </Routes>
      {/* </Router> */}
      </BrowserRouter>
    </>
  );
};

export default App;
